<template>
  <footer class="app-footer">
    <v-container class="footer-container">
      <v-row justify="space-between" class="footer-top">
        <v-col cols="12" md="4" class="footer-brand">
          <img
            src="@/assets/ozo_logo-mobile.svg"
            alt="OZO.direct"
            class="footer-logo mb-4"
          />
          <p class="brand-desc">
            OZO.direct — комплексная цифровая экосистема для ресторанного
            бизнеса. Мобильные приложения, программа лояльности и умная
            аналитика.
          </p>
        </v-col>

        <v-col cols="6" md="2" class="footer-links">
          <h4 class="links-title">Навигация</h4>
          <ul>
            <li><a href="#hero">Главная</a></li>
            <li><a href="#ecosystem">Экосистема</a></li>
            <li><a href="#advantages">Преимущества</a></li>
            <li><a href="#integrations">Интеграции</a></li>
          </ul>
        </v-col>

        <v-col cols="6" md="2" class="footer-links">
          <h4 class="links-title">Решения</h4>
          <ul>
            <li><a href="#analytics">OZO.OFFICE</a></li>
            <li><a href="#clients">Клиенты</a></li>
            <li><a href="#pricing">Тарифы</a></li>
            <li><a href="#contact">Демонстрация</a></li>
          </ul>
        </v-col>

        <v-col cols="12" md="3" class="footer-contacts">
          <h4 class="links-title">Контакты</h4>
          <p class="contact-line">
            Телефон / WhatsApp:<br />
            <a href="tel:+77017224666" class="contact-highlight"
              >+7 (701) 722-46-66</a
            >
          </p>
          <p class="contact-line">Email: <span>info@ozo.direct</span></p>
        </v-col>
      </v-row>

      <div class="footer-bottom">
        <div class="copyright">
          © {{ currentYear }} OZO.direct. Все права защищены.
        </div>
        <div class="legal-links">
          <span>Политика конфиденциальности</span>
          <span>Пользовательское соглашение</span>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.app-footer {
  background-color: #0b0c0e;
  color: #94a3b8;
  padding: 60px 0 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-container {
  max-width: $container-max-width;
  margin: 0 auto;
}

.footer-logo {
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
}

.brand-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
  max-width: 320px;
}

.links-title {
  font-family: $font-family-heading;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.footer-links {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    li a {
      color: #94a3b8;
      text-decoration: none;
      font-size: 14px;
      transition: color 0.2s;

      &:hover {
        color: $color-neon-green;
      }
    }
  }
}

.footer-contacts {
  .contact-line {
    font-size: 14px;
    color: #94a3b8;
    margin-bottom: 12px;
    line-height: 1.5;

    .contact-highlight {
      color: $color-neon-green;
      font-weight: 600;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.footer-bottom {
  margin-top: 50px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: #64748b;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    .legal-links {
      flex-direction: column;
      gap: 8px;
    }
  }

  .legal-links {
    display: flex;
    gap: 20px;
  }
}
</style>
